import CanCan from 'cancan';
import { IC_ISM_POSITIONS } from 'config/constants';
import { roleNotInstallerBased } from '../utils';

const cancan = new CanCan();
const { allow, can } = cancan;

// Entities
class Phase { }
class PhaseInfo { }
class PhaseSpecifics { }
class PhaseTask { }
class Event { }
class Schedule { }
class Dashboard {}
class LineItem { }
class Document { }
class Checklist { }
class Appointment { }
class AppointmentForm { }
class SuggestionOverride { }
class Pto { }
class TravelingWorkDate { }
class RelatedPhase { }
class Scraper { }
class Survey { }
class Communications { }
class MaterialsChecklist { }
class Labor { }
class Accounting { }
class PurchaseOrder { }
class LaborSheet { }
class LaborTotal { }
class ApprovedLabor { }
class ContractorLineItem { }
class Chargeback { }
class Warehouse { }
class Crew { }
class CrewSpecifics { }
class ProfitMargin { }
class DueDate { }
class TimeInPhase { }
class CreatedAtDefault { }
class Store { }
class StoreDetails { }
class StoreContact { }
class PricePatchUpload { }
class InstallationsPaperwork { }
class WarehouseReport { }
class TagsBulkPrint { }
class ActivityReport { }
class InstallWorkorderReport { }
class JobHistory { }
class Inactive { }
class PayRate { }
class Flag { }
class Contractor { }
class Badge { }
class CreateException { }
class Coc { }
class Walkthrough { }
class RepairInspectionReport { }
class CrewInspection { }
class BulkUpdateUpload { }
class MarginUpload { }
class ActivityUpload { }
class BulkProjectsLoad {}
class LowesSurveyUpload { }
class FloorWizard { }
class SendEmail { }
class LPA { }
class Leveler { }
class EstimatorDetails { }
class ManageVendors { }
class SupervisorFilter { }
class SupervisorInfo { }
class AssignInstaller { }
class InstallerPrioritizationWeights { }
class IfiLrrp { }
class DefaultInstallerPay { }
class HolidayPromoSettings { }
class SupportRequest { }
class NonIfi { }

// Roles
class Admin { }
class OfficeAdmin { }
class Regional { }
class Estimator { }
class Iqm { }
class Installer { }
class Employee { }
class Workroom { }
class LowesDocs { }
class ContractVerification { }
class ReviewsAndRefigures { }

export const Entities = {
  PHASE: new Phase(),
  PHASE_INFO: new PhaseInfo(),
  PHASE_SPECIFICS: new PhaseSpecifics(),
  PHASE_TASK: new PhaseTask(),
  EVENT: new Event(),
  SCHEDULE: new Schedule(),
  DASHBOARD: new Dashboard(),
  LINE_ITEM: new LineItem(),
  DOCUMENT: new Document(),
  CHECKLIST: new Checklist(),
  APPOINTMENT: new Appointment(),
  APPOINTMENT_FORM: new AppointmentForm(),
  SUGGESTION_OVERRIDE: new SuggestionOverride(),
  PTO: new Pto(),
  TRAVELING_WORK_DATE: new TravelingWorkDate(),
  RELATED_PHASE: new RelatedPhase(),
  SCRAPER: new Scraper(),
  SURVEY: new Survey(),
  COMMUNICATIONS: new Communications(),
  MATERIALS_CHECKLIST: new MaterialsChecklist(),
  LABOR: new Labor(),
  ACCOUNTING: new Accounting(),
  PURCHASE_ORDER: new PurchaseOrder(),
  LABOR_SHEET: new LaborSheet(),
  LABOR_TOTAL: new LaborTotal(),
  APPROVED_LABOR: new ApprovedLabor(),
  CONTRACTOR_LINE_ITEM: new ContractorLineItem(),
  CHARGEBACK: new Chargeback(),
  WAREHOUSE: new Warehouse(),
  PROFIT_MARGIN: new ProfitMargin(),
  DUE_DATE: new DueDate(),
  TIME_IN_PHASE: new TimeInPhase(),
  CREATED_AT_DEFAULT: new CreatedAtDefault(),
  STORE: new Store(),
  STORE_DETAILS: new StoreDetails(),
  STORE_CONTACT: new StoreContact(),
  PRICE_PATCH_UPLOAD: new PricePatchUpload(),
  INSTALLATIONS_PAPERWORK: new InstallationsPaperwork(),
  WAREHOUSE_REPORT: new WarehouseReport(),
  TAGS_BULK_PRINT: new TagsBulkPrint(),
  ACTIVITY_REPORT: new ActivityReport(),
  INSTALL_WORKORDER_REPORT: new InstallWorkorderReport(),
  JOB_HISTORY: new JobHistory(),
  EMPLOYEE: new Employee(),
  ESTIMATOR: new Estimator(),
  IQM: new Iqm(),
  INSTALLER: new Installer(),
  CREW: new Crew(),
  CREW_SPECIFICS: new CrewSpecifics(),
  PAY_RATE: new PayRate(),
  INACTIVE: new Inactive(),
  FLAG: new Flag(),
  CONTRACTOR: new Contractor(),
  BADGE: new Badge(),
  CREATE_EXCEPTION: new CreateException(),
  COC: new Coc(),
  WALKTHROUGH: new Walkthrough(),
  REPAIR_INSPECTION_REPORT: new RepairInspectionReport(),
  CREW_INSPECTION: new CrewInspection(),
  BULK_UPDATE_UPLOAD: new BulkUpdateUpload(),
  MARGIN_UPLOAD: new MarginUpload(),
  ACTIVITY_UPLOAD: new ActivityUpload(),
  BULK_PROJECTS_LOAD: new BulkProjectsLoad(),
  LOWES_SURVEY_UPLOAD: new LowesSurveyUpload(),
  WORKROOM: new Workroom(),
  FLOOR_WIZARD: new FloorWizard(),
  SEND_EMAIL: new SendEmail(),
  LPA: new LPA(),
  LEVELER: new Leveler(),
  ESTIMATOR_DETAILS: new EstimatorDetails(),
  MANAGE_VENDORS: new ManageVendors(),
  SUPERVISOR_FILTER: new SupervisorFilter(),
  SUPERVISOR_INFO: new SupervisorInfo(),
  ASSIGN_INSTALLER: new AssignInstaller(),
  INSTALLER_PRIORITIZATION_WEIGHTS: new InstallerPrioritizationWeights(),
  IFI_LRRP: new IfiLrrp(),
  DEFAULT_INSTALLER_PAY: new DefaultInstallerPay(),
  HOLIDAY_PROMO_SETTINGS: new HolidayPromoSettings(),
  SUPPORT_REQUEST: new SupportRequest(),
  NON_IFI: new NonIfi(),
};

export const Roles = {
  OFFICE_ADMIN: new OfficeAdmin(),
  REGIONAL: new Regional(),
  WORKROOM: new Workroom(),
  IQM: new Iqm(),
  LOWES_DOCS: new LowesDocs(),
  ACCOUNTING: new Accounting(),
  REVIEWS_AND_REFIGURES: new ReviewsAndRefigures(),
  ESTIMATOR: new Estimator(),
  INSTALLER: new Installer(),
  ADMIN: new Admin(),
  EMPLOYEE: new Employee(),
  CREW: new Crew(),
};

const PURCHASE_ORDER_STATUSES = ['Recorded', 'Invoiced', 'Paid'];
const LOWESDOC_LABOR_SHEET_STATUSES = ['Recorded', 'Approved by Contractor'];
const LABOR_SHEET_STATUSES = ['Recorded', 'Ready for Accounting'];
const ACTIVITY_MANAGERS = [
  'Fatima Singletary',
  'Kyle Reece',
  'Jimmy Chestnut',
  'Antoinette Kilpatrick',
  'Jasmine Cannon',
];

const self = (user, obj) =>
  user.attrs && user.attrs.user_id && user.attrs.user_id === obj.attrs.obj_id;

const employee = (klass) => {
  allow(klass, 'view', [Installer, Crew, Badge, ProfitMargin]);
  allow(klass, 'view_inactive', [Estimator, Installer]);
  allow(klass, 'view', [TagsBulkPrint, WarehouseReport, ActivityReport, InstallWorkorderReport, JobHistory]);
  allow(klass, 'override', Phase);
};

const phaseInfo = klass => allow(klass, 'view', PhaseInfo);

const recordable = (role, excludeLabor = false) => {
  const isAdmin = [OfficeAdmin, Regional].includes(role);
  allow(role, ['editable', 'view'], PurchaseOrder);
  allow(role, 'update', PurchaseOrder, (user, sheet) =>
    isAdmin || !PURCHASE_ORDER_STATUSES.includes(sheet.attrs.obj_status));
  allow(role, ['editable', 'view'], Chargeback);
  allow(role, 'update', Chargeback, (user, sheet = { attrs: {} }) =>
    !['Recorded', 'Uncollectable'].includes(sheet.attrs.obj_status || ''));
  if (excludeLabor) return;
  allow(role, ['editable', 'view', 'approve'], LaborSheet);
  const restrictedStatuses = role !== LowesDocs ?
    LABOR_SHEET_STATUSES : LOWESDOC_LABOR_SHEET_STATUSES;
  allow(role, 'update', LaborSheet, (user, sheet) =>
    !restrictedStatuses.includes(sheet.attrs.obj_status));
  if (isAdmin) allow(role, 'manage_closed', LaborSheet);
};

const approvedLabor = role => allow(role, 'manage', ApprovedLabor);

const phaseTasks = (role) => {
  if ([Installer, Crew].includes(role)) {
    allow(role, 'update', PhaseTask, (user, data) => {
      const { slug, status } = data.attrs;
      const hiddenSlugs = [
        'install_complete',
        'workorder_complete',
        'install_in_progress_call',
        'workorder_in_progress_call',
        'delivery_completed',
      ];
      const validStatus = ['installing', 'in_progress', 'delivery'].includes(status);
      if (slug) return (validStatus && !hiddenSlugs.includes(slug));
      return validStatus;
    });
  } else allow(role, 'update', PhaseTask);
};

const activityPerms = (role) => {
  allow(role, 'view', ActivityUpload);
  allow(role, 'manage', ActivityUpload, (user, activityAttrs = { attrs: { position: '', name: '' } }) =>
    activityAttrs.attrs.position === 'Customer Care Specialist' ||
      ACTIVITY_MANAGERS.includes(activityAttrs.attrs.name));
};

const bulkLoadPerms = (role) => {
  allow(role, 'manage', BulkProjectsLoad, (user, attrs = { attrs: { position: '' } }) =>
    role === OfficeAdmin || attrs.attrs.position === 'Customer Care Specialist');
};

const supervisorFilterCheck = (user, attrs = { attrs: {} }) => {
  const {
    position = '',
    manageVendorWorkrooms: { ifi = false } = {},
  } = attrs.attrs;

  if (!ifi) {
    return false;
  }

  // Check if role is above workroom (OfficeAdmin or Regional) or has IC/ISM position
  // Note: Admin has 'manage all' so won't reach this check
  return (user instanceof OfficeAdmin || user instanceof Regional) ||
    IC_ISM_POSITIONS.includes(position);
};

const ifiInfoCheck = (user, attrs = { attrs: {} }) => {
  const {
    position = '',
    mvw = attrs.attrs.manage_vendor_workrooms || {},
  } = attrs.attrs;
  const manage_vendor_workrooms = mvw;

  if (!manage_vendor_workrooms.ifi) {
    return false;
  }

  // Check if role is Admin, OfficeAdmin, or Regional (these can always view)
  if (user instanceof Admin || user instanceof OfficeAdmin || user instanceof Regional) {
    return true;
  }

  // If workroom role, check position
  if (user instanceof Workroom) {
    return IC_ISM_POSITIONS.includes(position);
  }

  return false;
};

const nonIfiExclusiveCheck = (user, attrs = { attrs: {} }) => {
  const { manage_vendor_workrooms: mvw = {} } = attrs.attrs;
  return Object.keys(mvw).some(key => key !== 'ifi' && mvw[key] === true);
};


const installerAssignedToPhaseCheck = (user, attrs = { attrs: {} }) => {
  const {
    phase_installer_id = null,
    employable_id = null,
  } = attrs.attrs;

  if (phase_installer_id == null || employable_id == null) {
    return false;
  }

  return Number(phase_installer_id) === Number(employable_id);
};

const quickScheduleIfiCheck = (user, attrs = { attrs: {} }) =>
  attrs.attrs.source === 'IFI';

const quickScheduleAssigneeCheck = phaseAssigneeKey => (user, attrs = { attrs: {} }) => {
  const {
    source = '',
    is_self_schedulable: isSelfSchedulable = false,
    employable_id: employableId = null,
  } = attrs.attrs;
  const phaseAssigneeId = attrs.attrs[phaseAssigneeKey];
  if (source !== 'IFI' || !isSelfSchedulable) return false;
  if (phaseAssigneeId == null || employableId == null) return false;
  return Number(phaseAssigneeId) === Number(employableId);
};

// Installers may quick-schedule Assessments and Installations, but never Workorders.
const installerQuickScheduleCheck = (user, attrs = { attrs: {} }) => {
  if (attrs.attrs.phase_type === 'Workorder') return false;
  return quickScheduleAssigneeCheck('phase_installer_id')(user, attrs);
};

const installerPrioritizationWeightsCheck = (user, attrs = { attrs: {} }) => {
  const {
    position = '',
    manageVendorWorkrooms: { ifi = false } = {},
  } = attrs.attrs;

  return ifi && (
    user instanceof OfficeAdmin ||
    user instanceof Regional ||
    IC_ISM_POSITIONS.includes(position)
  );
};

const estimatorDetails = (role) => {
  allow(role, 'view', EstimatorDetails, (user, obj) => obj.attrs.matching);
};

// Actions

// ********************* Base ********************

[OfficeAdmin, Regional, Workroom, LowesDocs, Accounting, ContractVerification,
  ReviewsAndRefigures, Estimator].forEach((klass) => {
    allow(klass, 'view', [
      Employee, Estimator, Iqm, Store, Phase, Appointment, Event, Workroom,
      Document, Survey, Communications, RelatedPhase, Pto, TravelingWorkDate, Flag, Schedule,
      DueDate, TimeInPhase, CreatedAtDefault, PhaseSpecifics, CrewSpecifics, Dashboard,
    ]);
    allow(klass, 'create', Event);
    allow(klass, 'manage', [DueDate, Document, Flag, MaterialsChecklist]);
  });

// ********************* Admin ********************

allow(Admin, 'manage', 'all');

// ********************* OfficeAdmin *********************

employee(OfficeAdmin);
allow(OfficeAdmin, 'manage', PricePatchUpload);
allow(OfficeAdmin, 'update', [Badge, Phase, RelatedPhase]);
allow(OfficeAdmin, 'manage', [Installer, Crew, Estimator, PayRate]);
allow(OfficeAdmin, ['create', 'copy', 'override', 'relate', 'cancel', 'verify_document', 'update_contractor_notes'],
  Phase);
allow(OfficeAdmin, 'manage', [Checklist, Appointment, AppointmentForm, Pto, TravelingWorkDate]);
allow(OfficeAdmin, 'manage', [Labor, Warehouse]);
allow(OfficeAdmin, 'view', [Accounting, LaborTotal]);
allow(OfficeAdmin, 'manage', [LaborSheet, ContractorLineItem, InstallationsPaperwork]);
allow(OfficeAdmin, 'manage', [Scraper, LowesSurveyUpload]);
allow(OfficeAdmin, 'update', Survey);
allow(OfficeAdmin, 'manage', Communications);
allow(OfficeAdmin, 'update', Store);
allow(OfficeAdmin, 'manage', StoreContact);
allow(OfficeAdmin, 'update', StoreDetails);
allow(OfficeAdmin, 'manage', Coc);
allow(OfficeAdmin, 'manage', Walkthrough);
allow(OfficeAdmin, 'manage', [RepairInspectionReport, CrewInspection, CreateException]);
allow(OfficeAdmin, 'manage', LPA);
allow(OfficeAdmin, 'view', SuggestionOverride);
allow(OfficeAdmin, 'update', FloorWizard);
allow(OfficeAdmin, 'manage', SendEmail);
allow(OfficeAdmin, 'manage', Leveler);
allow(OfficeAdmin, 'merge_to_original', PurchaseOrder);
allow(OfficeAdmin, 'view', SupervisorFilter, supervisorFilterCheck);
allow(OfficeAdmin, 'view', SupervisorInfo, ifiInfoCheck);
allow(OfficeAdmin, 'manage', AssignInstaller, ifiInfoCheck);
allow(OfficeAdmin, 'manage', IfiLrrp, ifiInfoCheck);
allow(OfficeAdmin, 'manage', DefaultInstallerPay);
allow(OfficeAdmin, 'manage', HolidayPromoSettings);
allow(OfficeAdmin, 'create', SupportRequest);
allow(OfficeAdmin, 'manage', InstallerPrioritizationWeights, installerPrioritizationWeightsCheck);
allow(OfficeAdmin, 'quick_schedule', Phase, quickScheduleIfiCheck);
allow(OfficeAdmin, 'view', NonIfi, nonIfiExclusiveCheck);
recordable(OfficeAdmin);
phaseTasks(OfficeAdmin);
phaseInfo(OfficeAdmin);
activityPerms(OfficeAdmin);
bulkLoadPerms(OfficeAdmin);

// ********************* Regional *********************

employee(Regional);
allow(Regional, 'update', [Phase, Survey, RelatedPhase]);
allow(Regional, 'manage', Communications);
allow(Regional, 'create', Phase);
allow(Regional, 'override', Phase);
allow(Regional, 'cancel', Phase);
allow(Regional, 'verify_document', Phase);
allow(Regional, 'update_contractor_notes', Phase);
allow(Regional, 'relate', Phase);
allow(Regional, 'manage', [Labor, Warehouse, Coc, Walkthrough, RepairInspectionReport,
  CrewInspection, CreateException, CrewSpecifics]);
allow(Regional, 'assign', Estimator);
allow(Regional, 'manage', [Checklist, Appointment, Pto, TravelingWorkDate, Accounting, ContractorLineItem,
  AppointmentForm, Contractor, Scraper]);
allow(Regional, 'copy', Phase);
allow(Regional, 'update', Store);
allow(Regional, 'manage', StoreContact);
allow(Regional, 'view', [PayRate, InstallationsPaperwork, LaborTotal]);
allow(Regional, 'manage', Estimator);
allow(Regional, 'resend', Installer);
allow(Regional, ['assign', 'update_basic'], [Installer, Crew]);
allow(Regional, 'manage', LPA);
allow(Regional, 'view', SuggestionOverride);
allow(Regional, 'update', FloorWizard);
allow(Regional, 'manage', Leveler);
allow(Regional, 'merge_to_original', PurchaseOrder);
allow(Regional, 'view', SupervisorFilter, supervisorFilterCheck);
allow(Regional, 'view', SupervisorInfo, ifiInfoCheck);
allow(Regional, 'manage', AssignInstaller, ifiInfoCheck);
allow(Regional, 'manage', IfiLrrp, ifiInfoCheck);
allow(Regional, 'create', SupportRequest);
allow(Regional, 'manage', InstallerPrioritizationWeights, installerPrioritizationWeightsCheck);
allow(Regional, 'quick_schedule', Phase, quickScheduleIfiCheck);
allow(Regional, 'view', NonIfi, nonIfiExclusiveCheck);
recordable(Regional);
phaseTasks(Regional);
phaseInfo(Regional);
activityPerms(Regional);

// ********************* Workroom *********************

employee(Workroom);
allow(Workroom, 'update', [Phase, Survey, RelatedPhase]);
allow(Workroom, 'manage', Communications);
allow(Workroom, 'create', Phase);
allow(Workroom, 'override', Phase);
allow(Workroom, 'cancel', Phase);
allow(Workroom, 'verify_document', Phase);
allow(Workroom, 'update_contractor_notes', Phase);
allow(Workroom, 'relate', Phase);
allow(Workroom, 'manage', [Labor, Warehouse, Coc, Walkthrough, RepairInspectionReport,
  CrewInspection, CreateException]);
allow(Workroom, ['assign', 'update'], Estimator);
allow(Workroom, 'manage', [Checklist, Appointment, Pto, TravelingWorkDate, Accounting, ContractorLineItem,
  AppointmentForm, Contractor, Scraper]);
allow(Workroom, 'copy', Phase);
allow(Workroom, 'update', Store);
allow(Workroom, 'manage', StoreContact);
allow(Workroom, 'view', [PayRate, InstallationsPaperwork, LaborTotal]);
allow(Workroom, ['assign', 'update_basic'], [Installer, Crew]);
allow(Workroom, 'update', FloorWizard);
allow(Workroom, 'manage', Leveler);
allow(Workroom, 'merge_to_original', PurchaseOrder);
allow(Workroom, 'view', SupervisorFilter, supervisorFilterCheck);
allow(Workroom, 'view', SupervisorInfo, ifiInfoCheck);
allow(Workroom, 'view', NonIfi, nonIfiExclusiveCheck);
allow(Workroom, 'manage', AssignInstaller, ifiInfoCheck);
allow(Workroom, 'manage', IfiLrrp, ifiInfoCheck);
allow(Workroom, 'manage', InstallerPrioritizationWeights, installerPrioritizationWeightsCheck);
allow(Workroom, 'quick_schedule', Phase, quickScheduleIfiCheck);
allow(Workroom, 'create', SupportRequest);
recordable(Workroom);
phaseTasks(Workroom);
phaseInfo(Workroom);
activityPerms(Workroom);
bulkLoadPerms(Workroom);

// ********************* Iqm *********************

employee(Iqm);
allow(Iqm, 'view', [PurchaseOrder, LaborSheet, ContractorLineItem, Phase, Employee,
  Estimator, Iqm, Store, Appointment, Event, Workroom, Document, Survey, RelatedPhase, Pto,
  TravelingWorkDate, Flag, Schedule, TimeInPhase, Labor, Warehouse, Installer, Crew]);
allow(Iqm, 'create', Event);
allow(Iqm, 'manage', Communications);
allow(Iqm, 'verify_document', Phase);
allow(Iqm, 'cancel', Phase);
allow(Iqm, 'override', Phase);
allow(Iqm, 'update_contractor_notes', Phase);
allow(Iqm, 'manage', [Appointment, Contractor, Document, Pto, Flag,
  Coc, Walkthrough, RepairInspectionReport, CrewInspection, MaterialsChecklist]);
allow(Iqm, ['editable', 'view'], Chargeback);
allow(Iqm, 'update', Chargeback, (user, sheet) => sheet.attrs.obj_status !== 'Recorded' || 'Uncollectable');
allow(Iqm, 'manage', AppointmentForm, iqmAttrs => iqmAttrs.attrs.user_name === iqmAttrs.attrs.obj_name);
allow(Iqm, 'view', [TagsBulkPrint, WarehouseReport, InstallationsPaperwork, InstallWorkorderReport, LaborTotal, JobHistory]);
allow(Iqm, 'view', NonIfi, nonIfiExclusiveCheck);
phaseTasks(Iqm);
phaseInfo(Iqm);

// ********************* LowesDocs *********************

employee(LowesDocs);
allow(LowesDocs, 'view', [RelatedPhase, InstallationsPaperwork, Warehouse, LaborTotal]);
allow(LowesDocs, 'manage', [Phase, Labor, Accounting, ContractorLineItem, Scraper]);
allow(LowesDocs, 'copy', Phase);
allow(LowesDocs, 'update', Store);
allow(LowesDocs, ['view', 'update', 'delete'], StoreContact);
allow(LowesDocs, 'view', NonIfi, nonIfiExclusiveCheck);
recordable(LowesDocs);
phaseTasks(LowesDocs);
phaseInfo(LowesDocs);

// ********************* Accounting *********************

employee(Accounting);
allow(Accounting, 'view', [Labor, ContractorLineItem, LaborTotal]);
allow(Accounting, 'override', Phase);
allow(Accounting, 'update', Phase);
allow(Accounting, 'update_contractor_notes', Phase);
allow(Accounting, 'manage', [Accounting, InstallationsPaperwork]);
allow(Accounting, 'copy', Phase);
allow(Accounting, 'manage', [BulkUpdateUpload, MarginUpload, Warehouse]);
allow(Accounting, ['editable', 'view', 'update', 'approve'], LaborSheet);
allow(Accounting, ['editable', 'view', 'update'], [Chargeback, PurchaseOrder, Labor]);
allow(Accounting, 'manage', Installer);
allow(Accounting, 'view', NonIfi, nonIfiExclusiveCheck);
approvedLabor(Accounting);
phaseTasks(Accounting);
phaseInfo(Accounting);

// ********************* ReviewsAndRefigures *********************

employee(ReviewsAndRefigures);
allow(ReviewsAndRefigures, 'override', Phase);
allow(ReviewsAndRefigures, 'cancel', Phase);
allow(ReviewsAndRefigures, 'update_contractor_notes', Phase);
allow(ReviewsAndRefigures, ['copy', 'update'], Phase);
allow(ReviewsAndRefigures, 'view', [Labor, LaborTotal]);
allow(ReviewsAndRefigures, 'update', Store);
allow(ReviewsAndRefigures, ['view', 'update', 'delete'], StoreContact);
allow(ReviewsAndRefigures, 'update', FloorWizard);
allow(ReviewsAndRefigures, 'view', NonIfi, nonIfiExclusiveCheck);
phaseTasks(ReviewsAndRefigures);
phaseInfo(ReviewsAndRefigures);

// ********************* Estimator ********************
allow(Estimator, 'update', Phase);
allow(Estimator, 'update_contractor_notes', Phase);
allow(Estimator, 'manage', Appointment);
allow(Estimator, 'view', [Accounting, LaborSheet, ContractorLineItem, LaborTotal, Workroom]);
allow(Estimator, 'manage', [AppointmentForm, Pto, TravelingWorkDate], self);
allow(Estimator, 'assign', Contractor, self);
allow(Estimator, 'view', [Badge], self);
allow(Estimator, 'update', FloorWizard);
allow(Estimator, 'view', NonIfi, nonIfiExclusiveCheck);
allow(Estimator, 'manage', SendEmail);
allow(Estimator, 'quick_schedule', Phase, quickScheduleAssigneeCheck('phase_estimator_id'));
phaseTasks(Estimator);
phaseInfo(Estimator);
estimatorDetails(Estimator);

// ********************* Installer ********************
allow(Installer, 'view', [
  Phase, Installer, Crew, Appointment, Document, Pto, TravelingWorkDate, Schedule, Workroom,
]);
allow(Installer, 'update_contractor_notes', Phase);
allow(Installer, 'create', Event);
allow(Installer, 'create', Flag, installerAssignedToPhaseCheck);
allow(Installer, 'view', Appointment);
allow(Installer, 'view', [Accounting, LaborSheet, ContractorLineItem, LaborTotal]);
allow(Installer, 'approve', LaborSheet);
allow(Installer, 'manage', [Coc, Walkthrough, RepairInspectionReport, CrewInspection, CreateException, MaterialsChecklist]);
allow(Installer, 'manage', IfiLrrp, installerAssignedToPhaseCheck);
allow(Installer, 'manage', [AppointmentForm, Pto, TravelingWorkDate], self);
allow(Installer, 'view', NonIfi, nonIfiExclusiveCheck);
// Installers may only schedule IFI appointments via Quick Schedule — never through the
// standard appointment create/manage flow.
allow(Installer, 'quick_schedule', Phase, installerQuickScheduleCheck);
phaseTasks(Installer);

// *********************** Crew **********************
allow(Crew, 'view', [
  Phase, Crew, Appointment, Document, Pto, TravelingWorkDate, Schedule,
]);
allow(Crew, 'update_contractor_notes', Phase);
allow(Crew, 'create', Event);
allow(Crew, 'view', Appointment);
allow(Crew, 'view', [Accounting, LaborSheet, ContractorLineItem]);
allow(Crew, 'approve', LaborSheet);
allow(Crew, 'manage', [Coc, Walkthrough, RepairInspectionReport, CrewInspection, CreateException, MaterialsChecklist]);
allow(Crew, 'manage', [AppointmentForm, Pto, TravelingWorkDate], self);
allow(Crew, 'view', NonIfi, nonIfiExclusiveCheck);
phaseTasks(Crew);

const canRole = (role, action, entity, attrs = {}) => {
  const roleObj = Roles[(role || '').toUpperCase()];
  if (!roleObj) return false;
  let entityObj;
  // In the case of viewing the 'L/P & Accounting' tab - passing in 2 entities
  if (Array.isArray(entity)) {
    for (let i = 0; i < entity.length; i += 1) {
      entityObj = Entities[(entity[i] || '').toUpperCase()];
      roleObj.attrs = attrs;
      entityObj.attrs = attrs;
      if (can(roleObj, action, entityObj) === true) return true;
    }
  // Every other tab - passing in 1 entity
  } else {
    entityObj = Entities[(entity || '').toUpperCase()];
  }
  if (!entityObj) return false;
  roleObj.attrs = attrs;
  entityObj.attrs = attrs;
  return can(roleObj, action, entityObj);
};

const canAccessCustomLaborSheet = ({ role = '', phase_source = '', mvw = {} } = {}) =>
  phase_source === 'IFI' && (role === 'installer' || !!mvw.ifi);

const canAccessIfiTemplate = ({ role = '', phase_type = '', phase_source = '' } = {}) =>
  roleNotInstallerBased(role) &&
  ['Assessment', 'Workorder'].includes(phase_type) &&
  phase_source === 'IFI';

export { canRole as can };
export { canAccessCustomLaborSheet };
export { canAccessIfiTemplate };



// WEBPACK FOOTER //
// ./client/app/services/ability.js